import React, { useEffect, useState, useContext } from "react";
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { ProductContext } from "../context/AppContext";
import axios from 'axios';
import Footer from './Common_Components/Footer';
import translations from "./translation";

function AppView() {

    const location = useLocation();
    const [activePage, setActivePage] = useState("");
    const navigate = useNavigate();
    const day = location.state?.day || "Day Module";
    const { languageData, username } = useContext(ProductContext);
    const authToken = localStorage.getItem("AuthToken");
    const selectedLanguage = localStorage.getItem("selectedLanguage") || "hindi";
    const localTranslations = translations[selectedLanguage === "hindi" ? "hindi" : "english"];
    const [plans, setPlans] = useState([]);
    const [isSubscriptionEmpty, setIsSubscriptionEmpty] = useState(false);
    const [activeSubscription, setActiveSubscription] = useState(null);
    const [upcomingSubscriptions, setUpcomingSubscriptions] = useState([]);
    const [orderId, setOrderId] = useState(null);
    const [key, setKey] = useState(null);
    const [price, setPrice] = useState('');
    const [planId, setPlanId] = useState('');
    const { Translate } = useContext(ProductContext);
    const [expandedPlanId, setExpandedPlanId] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const mobilePayLabel = "View Details & Continue on Website";

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            {/* <h2>{Translate?.message?.data?.Plans || localTranslations?.payment || "Japaking"}</h2> */}
                                                        <h2>Japaking</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className='logo_1' style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

             <div className="plans-tiles-container">
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-md-12 col-lg-12'>
                            <div style={{
                                backgroundColor: '#fff',
                                borderRadius: '12px',
                                padding: '20px',
                                marginTop: '20px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}>
                                <h4 style={{ fontWeight: 'bold', marginBottom: '12px' }}>
                                    Visit Our Website
                                </h4>
                                <p style={{ lineHeight: '1.6', color: '#555', fontSize: '16px', marginBottom: 0 }}>
                                    {selectedLanguage === "hindi"
                                        ? "जापानी भाषा सीखने का पूरा अनुभव पाने के लिए हमारी वेबसाइट पर जाएं। वेबसाइट पर आपको Hiragana, Katakana, Kanji, Vocabulary, Grammar, JLPT मॉक टेस्ट और जापान में पढ़ाई व नौकरी से जुड़ी पूरी जानकारी मिलेगी। अपने इसी अकाउंट से लॉगिन करके अपनी पढ़ाई वहीं से जारी रखें।"
                                        : "Visit our website for the complete Japanese learning experience. On the website you will find Hiragana, Katakana, Kanji, Vocabulary, Grammar, JLPT mock tests and complete information about studying and working in Japan. Log in with this same account and continue your learning from where you left off."}
                                </p>
                                <button
                                    className="plans-pay-button"
                                    onClick={() => navigate('/plans')}
                                >
                                    Continue on Website
                                </button>
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>

                                

            
            <Footer />
        </div>
    );
}

export default AppView